import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import iconDeleteRed from '../../../../assets/images/icon_delete_red.svg';
import iconAddOrange from '../../../../assets/images/icon_add_orange.svg';

import ModalAddTag from './Modals/AddTag';
import ModalEditTag from './Modals/EditTag';

import { TagActions } from '../../../../store/actions/tags';

import './style.css';

const SubMenuTags = ({ isActive, botId }) => {
  const [modalOpened, setModalOpened] = useState('');
  const [editingTag, setEditingTag] = useState({});

  const { tags } = useSelector((state) => state.tags.tagsState);

  const dispatch = useDispatch();

  useEffect(() => {
    if (botId) {
      dispatch(TagActions.list({ botId }));
    }
  }, [botId, dispatch]);

  const handleAddTag = useCallback(
    (values) => {
      dispatch(TagActions.create({ values, setModalOpened }));
    },
    [dispatch]
  );

  const handleEditTag = useCallback(
    ({ name, id }) => {
      const payload = { name, id, setModalOpened };
      dispatch(TagActions.edit(payload));
    },
    [dispatch]
  );

  const handleRemoveTag = useCallback(
    (id) => {
      dispatch(TagActions.remove({ id }));
    },
    [dispatch]
  );

  const handleSetEditingTag = useCallback((tag, modalName) => {
    setEditingTag(tag);
    setModalOpened(modalName);
  }, []);

  return (
    <div
      className={`menu-criador-submenu submenu--tag ${
        isActive ? '' : 'hidden'
      }`}
    >
      <h3 className="submenu__title">Tag</h3>

      <div className="submenu__content">
        <div className="submenu__column submenu__column--margin-right">
          <strong className="submenu__subtitle">Suas tags</strong>

          <ul className="submenu__list">
            {tags &&
              tags.bot &&
              tags.bot.map((tag) => (
                <li key={tag._id}>
                  <span onClick={() => handleSetEditingTag(tag, 'editTag')}>
                    {tag.name}
                  </span>
                  <button
                    type="button"
                    className="submenu__button"
                    onClick={() => handleRemoveTag(tag._id)}
                  >
                    <img src={iconDeleteRed} alt="Deletar variável" />
                  </button>
                </li>
              ))}
          </ul>

          <button
            type="button"
            className="submenu__button submenu__button--add"
            onClick={() => setModalOpened('addTag')}
          >
            <img src={iconAddOrange} alt="Adcionar tag" />
          </button>

          {modalOpened === 'addTag' && (
            <ModalAddTag
              isActive={modalOpened === 'addTag'}
              botId={botId}
              onClose={() => setModalOpened('')}
              onSubmit={(tags) => handleAddTag(tags)}
            />
          )}

          {modalOpened === 'editTag' && (
            <ModalEditTag
              isActive={modalOpened === 'editTag'}
              onClose={() => setModalOpened('')}
              initialData={editingTag}
              onSubmit={(tag) => handleEditTag(tag)}
            />
          )}
        </div>

        <div className="submenu__column">
          <strong className="submenu__subtitle">Tags padrão</strong>

          <ul className="submenu__list">
            {tags &&
              tags.global &&
              tags.global.map((tag) => <li key={tag._id}>{tag.name}</li>)}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SubMenuTags;
